import React from 'react';
import PropTypes from 'prop-types';
import InputElementWithLabel from './InputElementWithLabel.jsx';
import { caseInsensitiveComparison } from '../../../../../Common/Utilities/StringUtilities';
import { sortMapByProperty } from '../../../../../Common/Utilities/MapUtilities';
import AutoScopeStyles from '../../../../../Common/Utilities/Decorators/AutoScopeStylesDecorator'
import applyDecoratorsDoNotUseInNewCode from '../../../../../Common/Utilities/Decorators/ApplyDecorators.js';

class CheckboxRatesFilter extends React.Component {
    constructor() {
        super();
    }

    isItemSelected = (name) => !!this.props.selectedOptions.find(obj => obj.get('name') === name);

    render () {
        const searchIsInProgress = this.props.searchText.length > 0;
        const sortedVisibleValues = this.getAllVisibleValues();
        const filterOptions = sortedVisibleValues.map(filterOption =>
            <li
                key={ filterOption.get('id') }
                className="checkbox">
                <InputElementWithLabel
                    autoFocus={ !this.showSearchAndConvenienceButtons() && Object.is(filterOption, sortedVisibleValues.first()) }
                    label={ filterOption.get('name') }
                    value={ filterOption.get('id') }
                    isChecked={ this.isItemSelected(filterOption.get('name')) }
                    inputElementName="checkbox"
                    onChange={ this.onChange } />
            </li>);

        return (
            <div>
                {this.showSearchAndConvenienceButtons() ?
                    <span>
                        <input
                            className="ratesFilter search"
                            value={ this.props.searchText }
                            placeholder="Search"
                            onChange={ this.onSearchTextChanged }
                            autoFocus
                            type="search" />
                        <button
                            type="button"
                            className="ratesFilter selectAll secondary button"
                            onClick={ this.onSelectAllClicked }>
                            Select all
                        </button>
                        <button
                            type="button"
                            className="secondary button"
                            onClick={ this.onSelectNoneClicked }>
                            Deselect all
                        </button>
                        { searchIsInProgress ?
                            <button
                                type="button"
                                className="secondary button"
                                onClick={ this.onReplaceSelectionClicked }>
                                Replace selection
                            </button>
                        : null}
                    </span> :
                    null
                }
                <ul className="ratesFilter list">{filterOptions}</ul>
                { this.showFilterSummaryIfFilterInAction() }
            </div>
        )
    }

    getAllVisibleValues = () => {
        const caseInsensitiveContains = (str, search) => str.toLowerCase().indexOf(search.toLowerCase()) !== -1
        const visibleValues = this.props.options.filter(option => this.props.searchText.length === 0 || caseInsensitiveContains(option.get('name'), this.props.searchText));

        const sortedVisibleValues = sortMapByProperty(visibleValues, 'name', caseInsensitiveComparison);;
        return sortedVisibleValues;
    }

    showSearchAndConvenienceButtons = () => {
        const minimumNumberOfOptionsThreshold = 3
        return this.props.options.count() >= minimumNumberOfOptionsThreshold;
    }

    onSearchTextChanged = (event) => {
        this.props.onSearchTextChange(this.props.category, event.target.value);
    }

    showFilterSummaryIfFilterInAction = () => {
        const numberOfSelectedOptions = this.props.options.filter(v => this.isItemSelected(v.get('name'))).size;
        const numberOfVisibleSelectedOptions = this.getAllVisibleValues().filter(v => this.isItemSelected(v.get('name'))).size;
        const numberOfInvisibleSelectedItems = numberOfSelectedOptions - numberOfVisibleSelectedOptions;
        if(numberOfInvisibleSelectedItems === 0)
            return null;

        return <aside className="ratesFilter information">
            <p>
                {numberOfInvisibleSelectedItems} selected { numberOfInvisibleSelectedItems === 1 ? "item is" : "items are" } not shown due to the current search.<br/>
                Use the <strong>Select all</strong> and <strong>Deselect all</strong> buttons to select or deselect the items you can see without affecting the items not shown here.<br/>
                Use the <strong>Replace selection</strong> button to deselect other items and select only the items selected on the current screen.
            </p>
        </aside>
    }

    onChange = (value, isSelected) => {
        const selectedValues = this.props.selectedOptions;
        const changedValueId = value.get('id');
        const newSelectedValues = isSelected ?
            selectedValues.push(value) :
            selectedValues.filter((selectedValue) => selectedValue.get('id') != changedValueId);

        this.props.onSelectedValuesChange(this.props.category, newSelectedValues, this.props.searchText);
    }

    onSelectAllClicked = () => {
        const newOptions = this.props.selectedOptions.concat(this.getAllVisibleValues()).toSet().toList();
        this.props.onSelectedValuesChange(this.props.category, newOptions);
    }

    onSelectNoneClicked = () => {
        const toDeselect = this.getAllVisibleValues().map(v => v.get('id'));
        const newOptions = this.props.selectedOptions.filter(opt => !toDeselect.contains(opt.get('id')))
        this.props.onSelectedValuesChange(this.props.category, newOptions);
    }

    onReplaceSelectionClicked = () => {
        const visibleValues = this.getAllVisibleValues().map(v => v.get('id'));
        const selectedVisibleValues = this.props.selectedOptions.filter(opt => visibleValues.contains(opt.get('id')));
        this.props.onSelectedValuesChange(this.props.category, selectedVisibleValues.toList());
    }

    static propTypes = {
        category: PropTypes.string.isRequired,
        options: PropTypes.object.isRequired,
        selectedOptions: PropTypes.object.isRequired,
        searchText: PropTypes.string.isRequired,
        onSelectedValuesChange: PropTypes.func.isRequired, //onSelectedValuesChange(category: string, newSelectedValues: array<{id, name}>)
        onSearchTextChange: PropTypes.func.isRequired //onSearchTextChange(category: string, newSearchText: string)
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(AutoScopeStyles);

export default withDecorators(CheckboxRatesFilter);
